import { useState } from "react";
import { LoadingMessage } from "./loading/LoadingMessage";
import { LoadingBar } from "./loading/LoadingBar";
import { 
  TOTAL_TIME, 
  UPDATE_INTERVAL, 
  MESSAGE_CHANGE_INTERVAL, 
  BLINK_DURATION,
  TIMEOUT_DURATION,
  messages,
  overtimeMessages
} from "./loading/constants";

export function LoadingProgress() {
  const [isOvertime, setIsOvertime] = useState(false);
  const [hasTimedOut, setHasTimedOut] = useState(false);

  return (
    <div className="space-y-16 w-full max-w-4xl mx-auto px-8">
      {hasTimedOut ? (
        <div className="flex flex-col items-center gap-6">
          <span className="text-6xl">⚠️</span>
          <p className="text-2xl font-medium text-center text-gray-800">
            Desculpe, não conseguimos completar a análise no tempo esperado.
            Por favor, tente novamente.
          </p>
        </div>
      ) : (
        <>
          <LoadingMessage
            messages={messages}
            overtimeMessages={overtimeMessages}
            isOvertime={isOvertime}
            messageChangeInterval={MESSAGE_CHANGE_INTERVAL}
            blinkDuration={BLINK_DURATION}
          />
          <LoadingBar
            totalTime={TOTAL_TIME}
            timeoutDuration={TIMEOUT_DURATION}
            updateInterval={UPDATE_INTERVAL}
            onOvertime={() => setIsOvertime(true)}
            onTimeout={() => setHasTimedOut(true)}
          />
        </>
      )}
    </div>
  );
}